export const POPEYE_URL = `${process.env.GATSBY_POPEYE_URL}`
export const BRUTUS_URL = `${process.env.GATSBY_BRUTUS_URL}`

//TODO: depcreated
export const ICONTAINERS_URL = `${process.env.GATSBY_ICONTAINERS_URL}`

export const OLIVIA_API_URL = `${process.env.GATSBY_OLIVIA_API_URL}`

export const POPEYE_QUOTE_URL = `${POPEYE_URL}/quote-form`
